module.exports = __webpack_public_path__ + "img/ent-workshop.f0677fef.jpg";